import axios from 'axios';

const PageService = {
    pageCache: {},
    getCached: function (id) {
        if ('prerenderedJSON' in window && id in window.prerenderedJSON) {
            return window.prerenderedJSON[id];
        }
        if (id in this.pageCache) {
            return this.pageCache[id];
        }
        var encid = encodeURIComponent(id);
        var ls = localStorage.getItem("lthub_cached_page_" + encid);
        if (ls) {
            var jls = JSON.parse(ls);
            this.pageCache[id] = jls;
            return jls;
        }
        return null;
    },
    getPage: function(request) {
        var self = this;
        if ('prerenderedJSON' in window && request.id in window.prerenderedJSON) {
            return new Promise((resolve, reject) => {
                resolve({ "data": { "data": window.prerenderedJSON[request.id] } });
            });
        }
        request.id = encodeURIComponent(request.id);
        return axios.get("api/pages/" + request.id, { params: request }, { withCredentials: true }).then((response) => {
            self.pageCache[request.id] = response.data.data;
            var encid = encodeURIComponent(request.id);
            localStorage.setItem("lthub_cached_page_" + encid, JSON.stringify(response.data.data));
            return response;
        });
    },
    getList: (request) => {
        return axios.get("api/pages/list", { params: request }, { withCredentials: true });
    },
    getListSimple: (request) => {
        return axios.get("api/pages/picklist", { params: request }, { withCredentials: true });
    },
    getListVersions: (request) => {
        return axios.get("api/pages/restorelist", { params: request }, { withCredentials: true });
    },
    getAutocomplete: (request) => {
        return axios.get("api/pages/autocomplete", { params: request }, { withCredentials: true });
    },
    updatePage: (request) => {
        return axios.put("api/pages", request, { withCredentials: true });
    },
    approvePage: (request) => {
        return axios.put("api/pages/approve", request, { withCredentials: true });
    },
    restorePage: (request) => {
        return axios.put("api/pages/restore", request, { withCredentials: true });
    },
    revertPage: (request) => {
        return axios.put("api/pages/revert", request, { withCredentials: true });
    },
    deletePage: (request) => {
        return axios.delete("api/pages/" + request.id, {}, { withCredentials: true });
    },
    autocomplete: (area, term, offset) => {
        return axios.get(`api/pages/autocomplete/${area}/${term}`, { offset }, { withCredentials: true });
    },
};

export default PageService;